<template>
    <BaseSelect
      v-model="modelValue"
      v-bind="$attrs"
      :options="YES_NO_OPTIONS"
      :displayType="displayflex"        
      size="sm"
      rules="required"
    >
      <template v-slot:label>Loss Fund Established? <span class="text-danger">*</span></template>
  
      <template v-slot:first>
        <b-form-select-option :value="undefined" disabled
          >Select</b-form-select-option
        >
      </template>
    </BaseSelect>
  </template>
  
  <script>
  import { defineComponent, computed } from '@vue/composition-api'  
  import { YES_NO_OPTIONS } from '@constants'  
  import { BaseSelect } from '@components/base'
  
  export default defineComponent({
    name: 'CashCallEstablishedLossFund',
    components: {
      BaseSelect
    },
    props: {
      value: Boolean,
      displayType: String
    },
    emits: ['input'],
    setup(props, { emit }) {   

      const displayflex = "dropdownWidth-sm"
  
      const modelValue = computed({
        get: () => props.value,
        set: (newValue) => emit('input', newValue)
      })   
  
      return {
        YES_NO_OPTIONS,  
        modelValue,
        displayflex
      }
    }
  })
  </script>
  